import {isEqual} from "lodash"
import PropTypes from "prop-types"
import React, {Component} from "react"

import {SelectDropdown} from "~/components/"

export default class SelectField extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    getInitialValue: PropTypes.func
  }

  constructor(props, context) {
    super(props)

    this.state = {
      value: context.getInitialValue
        ? context.getInitialValue(this.props.name)
        : ""
    }
  }

  componentDidMount() {
    const {value} = this.getCurrentOption()
    this.setState({value})

    if (this.context.onChange) {
      this.context.onChange(this.props.name, value)
    }

    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  getCurrentOption() {
    const value = this.props.value || this.state.value

    const currentOption = this.props.options.find(option =>
      isEqual(option.id, value)
    )

    if (currentOption) {
      return {
        name: currentOption.name,
        value
      }
    } else if (this.props.options.length > 0) {
      return {
        name: this.props.options[0].name,
        value: this.props.options[0].id
      }
    }
    return {name: "", value: null}
  }

  onSelect(option) {
    this.setState({
      value: option.id
    })
    if (this.context.onChange) {
      this.context.onChange(this.props.name, option.id)
    }
    if (this.props.onChange) {
      this.props.onChange(option.id)
    }
  }

  render() {
    const {name: currentName} = this.getCurrentOption()

    return (
      <SelectDropdown
        value={currentName}
        onSelect={options => this.onSelect(options)}
        name={this.props.name}
        label={this.props.label}
        options={this.props.options}
      />
    )
  }
}

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/fields/SelectField.js